import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../arcade/FunctionWrapper.js";
import t from "../arcade/ImmutableArray.js";
import n from "../arcade/ImmutablePathArray.js";
import r from "../arcade/ImmutablePointArray.js";
import { create as i, resolve as a, all as o } from "../core/promiseUtils.js";
import s from "../geometry/Extent.js";
import u from "../geometry/Geometry.js";
import l from "../geometry/Multipoint.js";
import f from "../geometry/Point.js";
import c from "../geometry/Polygon.js";
import m from "../geometry/Polyline.js";
import { DateTime as g } from "luxon";
import { isNone as d } from "../core/maybe.js";
import { format as h, parse as p } from "../core/number.js";
import { isClockwise as y } from "../geometry/support/coordsUtils.js";
import { getLocale as x } from "../intl/locale.js";

var S = function S(e) {
  _classCallCheck(this, S);

  this.value = e;
};

var b = function b(e) {
  _classCallCheck(this, b);

  this.value = e;
};

var T = function T(e) {
  _classCallCheck(this, T);

  this.fn = e;
};

var N = function N(e, t) {
  _classCallCheck(this, N);

  this.paramCount = t, this.fn = e;
};

var M = T,
    k = b,
    R = S,
    A = N,
    D = {
  type: "VOID"
},
    j = {
  type: "BREAK"
},
    C = {
  type: "CONTINUE"
};

function _(e, t, n) {
  return "" === t || null == t || t === n || t === n ? e : e = e.split(t).join(n);
}

function v(t) {
  return t instanceof T || t instanceof e || t instanceof N;
}

function w(e) {
  return !!Z(e) || !!F(e) || !!G(e) || !!Y(e) || null === e || e === D || "number" == typeof e;
}

function O(e, t) {
  return void 0 === e ? t : e;
}

function Z(e) {
  return "string" == typeof e || e instanceof String;
}

function Y(e) {
  return "boolean" == typeof e;
}

function F(e) {
  return "number" == typeof e;
}

function I(e) {
  return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
}

function J(e) {
  return e instanceof Array;
}

function L(e) {
  return !0 === (e && e.declaredRootClass && "esri.arcade.featureset.support.FeatureSet" === e.declaredRootClass);
}

function E(e) {
  return !0 === (e && e.declaredRootClass && "esri.arcade.featureSetCollection" === e.declaredRootClass);
}

function z(e) {
  return e instanceof t;
}

function G(e) {
  return e instanceof Date;
}

function P(e, t, n) {
  if (e.length < t || e.length > n) throw new Error("Function called with wrong number of Parameters");
}

function V(e) {
  return e < 0 ? -Math.round(-e) : Math.round(e);
}

function H() {
  var e = new Date().getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
    var n = (e + 16 * Math.random()) % 16 | 0;
    return e = Math.floor(e / 16), ("x" === t ? n : 3 & n | 8).toString(16);
  });
}

function U(e, t) {
  return !1 === isNaN(e) ? null == t || "" === t ? e.toString() : (t = _(t, "‰", ""), t = _(t, "¤", ""), h(e, {
    pattern: t
  })) : e.toString();
}

function q(e, t) {
  var n = g.fromJSDate(e);
  return null == t || "" === t ? n.toISO({
    suppressMilliseconds: !0
  }) : n.toFormat($(t), {
    locale: x(),
    numberingSystem: "latn"
  });
}

function $(e) {
  e = e.replace(/LTS|LT|LL?L?L?|l{1,4}/g, "[$&]");
  var t = "";
  var n = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

  var _iterator = _createForOfIteratorHelper(e.match(n)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;

      switch (_r) {
        case "D":
          t += "d";
          break;

        case "DD":
          t += "dd";
          break;

        case "DDD":
          t += "o";
          break;

        case "d":
          t += "c";
          break;

        case "ddd":
          t += "ccc";
          break;

        case "dddd":
          t += "cccc";
          break;

        case "M":
          t += "L";
          break;

        case "MM":
          t += "LL";
          break;

        case "MMM":
          t += "LLL";
          break;

        case "MMMM":
          t += "LLLL";
          break;

        case "YY":
          t += "yy";
          break;

        case "Y":
        case "YYYY":
          t += "yyyy";
          break;

        case "Q":
          t += "q";
          break;

        case "Z":
          t += "ZZ";
          break;

        case "ZZ":
          t += "ZZZ";
          break;

        case "S":
          t += "'S'";
          break;

        case "SS":
          t += "'SS'";
          break;

        case "SSS":
          t += "u";
          break;

        case "A":
        case "a":
          t += "a";
          break;

        case "m":
        case "mm":
        case "h":
        case "hh":
        case "H":
        case "HH":
        case "s":
        case "ss":
        case "X":
        case "x":
          t += _r;
          break;

        default:
          _r.length >= 2 && "[" === _r.slice(0, 1) && "]" === _r.slice(-1) ? t += "'".concat(_r.slice(1, -1), "'") : t += "'".concat(_r, "'");
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t;
}

function B(e, t, n) {
  switch (n) {
    case ">":
      return e > t;

    case "<":
      return e < t;

    case ">=":
      return e >= t;

    case "<=":
      return e <= t;
  }

  return !1;
}

function W(e, t, n) {
  if (null === e) {
    if (null === t || t === D) return B(null, null, n);
    if (F(t)) return B(0, t, n);
    if (Z(t)) return B(0, ne(t), n);
    if (Y(t)) return B(0, ne(t), n);
    if (G(t)) return B(0, t.getTime(), n);
  }

  if (e === D) {
    if (null === t || t === D) return B(null, null, n);
    if (F(t)) return B(0, t, n);
    if (Z(t)) return B(0, ne(t), n);
    if (Y(t)) return B(0, ne(t), n);
    if (G(t)) return B(0, t.getTime(), n);
  } else if (F(e)) {
    if (F(t)) return B(e, t, n);
    if (Y(t)) return B(e, ne(t), n);
    if (null === t || t === D) return B(e, 0, n);
    if (Z(t)) return B(e, ne(t), n);
    if (G(t)) return B(e, t.getTime(), n);
  } else if (Z(e)) {
    if (Z(t)) return B(X(e), X(t), n);
    if (G(t)) return B(ne(e), t.getTime(), n);
    if (F(t)) return B(ne(e), t, n);
    if (null === t || t === D) return B(ne(e), 0, n);
    if (Y(t)) return B(ne(e), ne(t), n);
  } else if (G(e)) {
    if (G(t)) return B(e, t, n);
    if (null === t || t === D) return B(e.getTime(), 0, n);
    if (F(t)) return B(e.getTime(), t, n);
    if (Y(t)) return B(e.getTime(), ne(t), n);
    if (Z(t)) return B(e.getTime(), ne(t), n);
  } else if (Y(e)) {
    if (Y(t)) return B(e, t, n);
    if (F(t)) return B(ne(e), ne(t), n);
    if (G(t)) return B(ne(e), t.getTime(), n);
    if (null === t || t === D) return B(ne(e), 0, n);
    if (Z(t)) return B(ne(e), ne(t), n);
  }

  return !!Q(e, t) && ("<=" === n || ">=" === n);
}

function Q(e, t) {
  if (e === t) return !0;
  if (null === e && t === D || null === t && e === D) return !0;
  if (G(e) && G(t)) return e.getTime() === t.getTime();
  if (e instanceof n) return e.equalityTest(t);
  if (e instanceof r) return e.equalityTest(t);

  if (e instanceof f && t instanceof f) {
    var _n = e.cache._arcadeCacheId,
        _r2 = t.cache._arcadeCacheId;
    if (null != _n) return _n === _r2;
  }

  if (void 0 !== e && void 0 !== t && null !== e && null !== t && "object" == typeof e && "object" == typeof t) {
    if (e._arcadeCacheId === t._arcadeCacheId && void 0 !== e._arcadeCacheId && null !== e._arcadeCacheId) return !0;
    if (e._underlyingGraphic === t._underlyingGraphic && void 0 !== e._underlyingGraphic && null !== e._underlyingGraphic) return !0;
  }

  return !1;
}

function X(e, n) {
  if (Z(e)) return e;
  if (null === e) return "";
  if (F(e)) return U(e, n);
  if (Y(e)) return e.toString();
  if (G(e)) return q(e, n);
  if (e instanceof u) return JSON.stringify(e.toJSON());

  if (J(e)) {
    var _t = [];

    for (var _n2 = 0; _n2 < e.length; _n2++) {
      _t[_n2] = te(e[_n2]);
    }

    return "[" + _t.join(",") + "]";
  }

  if (e instanceof t) {
    var _t2 = [];

    for (var _n3 = 0; _n3 < e.length(); _n3++) {
      _t2[_n3] = te(e.get(_n3));
    }

    return "[" + _t2.join(",") + "]";
  }

  return null !== e && "object" == typeof e && void 0 !== e.castToText ? e.castToText() : v(e) ? "object, Function" : "";
}

function K(e) {
  var n = [];
  if (!1 === J(e)) return null;

  if (e instanceof t) {
    for (var _t3 = 0; _t3 < e.length(); _t3++) {
      n[_t3] = ne(e.get(_t3));
    }

    return n;
  }

  for (var _t4 = 0; _t4 < e.length; _t4++) {
    n[_t4] = ne(e[_t4]);
  }

  return n;
}

function ee(e, n) {
  if (Z(e)) return e;
  if (null === e) return "";
  if (F(e)) return U(e, n);
  if (Y(e)) return e.toString();
  if (G(e)) return q(e, n);
  if (e instanceof u) return e instanceof s ? '{"xmin":' + e.xmin.toString() + ',"ymin":' + e.ymin.toString() + "," + (e.hasZ ? '"zmin":' + e.zmin.toString() + "," : "") + (e.hasM ? '"mmin":' + e.mmin.toString() + "," : "") + '"xmax":' + e.xmax.toString() + ',"ymax":' + e.ymax.toString() + "," + (e.hasZ ? '"zmax":' + e.zmax.toString() + "," : "") + (e.hasM ? '"mmax":' + e.mmax.toString() + "," : "") + '"spatialReference":' + ge(e.spatialReference) + "}" : ge(e.toJSON(), function (e, t) {
    return e.key === t.key ? 0 : "spatialReference" === e.key ? 1 : "spatialReference" === t.key || e.key < t.key ? -1 : e.key > t.key ? 1 : 0;
  });

  if (J(e)) {
    var _t5 = [];

    for (var _n4 = 0; _n4 < e.length; _n4++) {
      _t5[_n4] = te(e[_n4]);
    }

    return "[" + _t5.join(",") + "]";
  }

  if (e instanceof t) {
    var _t6 = [];

    for (var _n5 = 0; _n5 < e.length(); _n5++) {
      _t6[_n5] = te(e.get(_n5));
    }

    return "[" + _t6.join(",") + "]";
  }

  return null !== e && "object" == typeof e && void 0 !== e.castToText ? e.castToText() : v(e) ? "object, Function" : "";
}

function te(e) {
  if (null === e) return "null";
  if (Y(e) || F(e) || Z(e)) return JSON.stringify(e);
  if (e instanceof u) return ee(e);
  if (e instanceof t) return ee(e);
  if (e instanceof Array) return ee(e);
  if (e instanceof Date) return JSON.stringify(q(e, ""));

  if (null !== e && "object" == typeof e) {
    if (void 0 !== e.castToText) return e.castToText();
  } else if (e === D) return "null";

  return "null";
}

function ne(e, t) {
  return F(e) ? e : null === e || "" === e ? 0 : G(e) ? NaN : Y(e) ? e ? 1 : 0 : J(e) || "" === e || void 0 === e ? NaN : void 0 !== t && Z(e) ? (t = _(t, "‰", ""), t = _(t, "¤", ""), p(e, {
    pattern: t
  })) : e === D ? 0 : Number(e);
}

function re(e) {
  if (G(e)) return e;

  if (Z(e)) {
    var _t7 = ae(e);

    if (_t7) return _t7.toJSDate();
  }

  return null;
}

function ie(e) {
  return G(e) ? g.fromJSDate(e) : Z(e) ? ae(e) : null;
}

function ae(e) {
  var t = / (\d\d)/;
  var n = g.fromISO(e);
  return n.isValid || t.test(e) && (e = e.replace(t, "T$1"), n = g.fromISO(e), n.isValid) ? n : null;
}

function oe(e) {
  return Y(e) ? e : Z(e) ? "true" === (e = e.toLowerCase()) : !!F(e) && 0 !== e && !isNaN(e);
}

function se(e, t) {
  return d(e) ? null : (null !== e.spatialReference && void 0 !== e.spatialReference || (e.spatialReference = t), e);
}

function ue(e) {
  if (null === e) return null;
  if (e instanceof f) return "NaN" === e.x || null === e.x || isNaN(e.x) ? null : e;

  if (e instanceof c) {
    if (0 === e.rings.length) return null;

    var _iterator2 = _createForOfIteratorHelper(e.rings),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _t8 = _step2.value;
        if (_t8.length > 0) return e;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return null;
  }

  if (e instanceof m) {
    if (0 === e.paths.length) return null;

    var _iterator3 = _createForOfIteratorHelper(e.paths),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _t9 = _step3.value;
        if (_t9.length > 0) return e;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return null;
  }

  return e instanceof l ? 0 === e.points.length ? null : e : e instanceof s ? "NaN" === e.xmin || null === e.xmin || isNaN(e.xmin) ? null : e : null;
}

function le(e, t) {
  if (!e) return t;
  if (!e.domain) return t;
  var n = null;
  if ("string" === e.field.type || "esriFieldTypeString" === e.field.type) t = X(t);else {
    if (null == t) return null;
    if ("" === t) return t;
    t = ne(t);
  }

  for (var _r3 = 0; _r3 < e.domain.codedValues.length; _r3++) {
    var _i = e.domain.codedValues[_r3];
    _i.code === t && (n = _i);
  }

  return null === n ? t : n.name;
}

function fe(e, t) {
  if (!e) return t;
  if (!e.domain) return t;
  var n = null;
  t = X(t);

  for (var _r4 = 0; _r4 < e.domain.codedValues.length; _r4++) {
    var _i2 = e.domain.codedValues[_r4];
    _i2.name === t && (n = _i2);
  }

  return null === n ? t : n.code;
}

function ce(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var r = arguments.length > 3 ? arguments[3] : undefined;
  if (!t) return null;
  if (!t.fields) return null;
  var i,
      a,
      o = null;

  for (var _s = 0; _s < t.fields.length; _s++) {
    var _n6 = t.fields[_s];
    _n6.name.toLowerCase() === e.toString().toLowerCase() && (o = _n6);
  }

  if (null === o) throw new Error("Field not found");
  return r || (r = n && t.typeIdField && n._field(t.typeIdField)), null != r && t.types.some(function (e) {
    return e.id === r && (i = e.domains && e.domains[o.name], i && "inherited" === i.type && (i = me(o.name, t), a = !0), !0);
  }), a || i || (i = me(e, t)), {
    field: o,
    domain: i
  };
}

function me(e, t) {
  var n;
  return t.fields.some(function (t) {
    return t.name.toLowerCase() === e.toLowerCase() && (n = t.domain), !!n;
  }), n;
}

function ge(e, t) {
  t || (t = {}), "function" == typeof t && (t = {
    cmp: t
  });
  var n = "boolean" == typeof t.cycles && t.cycles,
      r = t.cmp && (i = t.cmp, function (e) {
    return function (t, n) {
      var r = {
        key: t,
        value: e[t]
      },
          a = {
        key: n,
        value: e[n]
      };
      return i(r, a);
    };
  });
  var i;
  var a = [];
  return function e(t) {
    if (t && t.toJSON && "function" == typeof t.toJSON && (t = t.toJSON()), void 0 === t) return;
    if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
    if ("object" != typeof t) return JSON.stringify(t);
    var i, o;

    if (Array.isArray(t)) {
      for (o = "[", i = 0; i < t.length; i++) {
        i && (o += ","), o += e(t[i]) || "null";
      }

      return o + "]";
    }

    if (null === t) return "null";

    if (-1 !== a.indexOf(t)) {
      if (n) return JSON.stringify("__cycle__");
      throw new TypeError("Converting circular structure to JSON");
    }

    var s = a.push(t) - 1,
        u = Object.keys(t).sort(r && r(t));

    for (o = "", i = 0; i < u.length; i++) {
      var _n7 = u[i],
          _r5 = e(t[_n7]);

      _r5 && (o && (o += ","), o += JSON.stringify(_n7) + ":" + _r5);
    }

    return a.splice(s, 1), "{" + o + "}";
  }(e);
}

function de(e) {
  if (null === e) return null;
  var t = [];

  var _iterator4 = _createForOfIteratorHelper(e),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _n8 = _step4.value;
      _n8 && (_n8.declaredClass && "esri.arcade.Feature" === _n8.declaredClass || "FeatureSetReader" === _n8.type) ? t.push(_n8.geometry()) : t.push(_n8);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return t;
}

function he(e, t) {
  if (!(t instanceof f)) throw new Error("Invalid Argument");
  e.push(t.hasZ ? t.hasM ? [t.x, t.y, t.z, t.m] : [t.x, t.y, t.z] : [t.x, t.y]);
}

function pe(e, t) {
  if (J(e) || z(e)) {
    var _n9 = !1,
        _i3 = !1,
        _a = [],
        _o = t;

    if (J(e)) {
      var _iterator5 = _createForOfIteratorHelper(e),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _t10 = _step5.value;
          he(_a, _t10);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      _a.length > 0 && (_o = e[0].spatialReference, _n9 = e[0].hasZ, _i3 = e[0].hasM);
    } else if (e instanceof r) _a = e._elements, _a.length > 0 && (_n9 = e._hasZ, _i3 = e._hasM, _o = e.get(0).spatialReference);else {
      if (!z(e)) throw new Error("Invalid Argument");

      var _iterator6 = _createForOfIteratorHelper(e.toArray()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t11 = _step6.value;
          he(_a, _t11);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      _a.length > 0 && (_o = e.get(0).spatialReference, _n9 = !0 === e.get(0).hasZ, _i3 = !0 === e.get(0).hasM);
    }

    if (0 === _a.length) return null;
    return !1 === y(_a, _i3, _n9) && (_a = _a.slice(0).reverse()), new c({
      rings: [_a],
      spatialReference: _o,
      hasZ: _n9,
      hasM: _i3
    });
  }

  return e;
}

function ye(e, t) {
  if (J(e) || z(e)) {
    var _n10 = !1,
        _i4 = !1,
        _a2 = [],
        _o2 = t;

    if (J(e)) {
      var _iterator7 = _createForOfIteratorHelper(e),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _t12 = _step7.value;
          he(_a2, _t12);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      _a2.length > 0 && (_o2 = e[0].spatialReference, _n10 = !0 === e[0].hasZ, _i4 = !0 === e[0].hasM);
    } else if (e instanceof r) _a2 = e._elements, _a2.length > 0 && (_n10 = e._hasZ, _i4 = e._hasM, _o2 = e.get(0).spatialReference);else if (z(e)) {
      var _iterator8 = _createForOfIteratorHelper(e.toArray()),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _t13 = _step8.value;
          he(_a2, _t13);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      _a2.length > 0 && (_o2 = e.get(0).spatialReference, _n10 = !0 === e.get(0).hasZ, _i4 = !0 === e.get(0).hasM);
    }

    return 0 === _a2.length ? null : new m({
      paths: [_a2],
      spatialReference: _o2,
      hasZ: _n10,
      hasM: _i4
    });
  }

  return e;
}

function xe(e, t) {
  if (J(e) || z(e)) {
    var _n11 = !1,
        _i5 = !1,
        _a3 = [],
        _o3 = t;

    if (J(e)) {
      var _iterator9 = _createForOfIteratorHelper(e),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _t14 = _step9.value;
          he(_a3, _t14);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      _a3.length > 0 && (_o3 = e[0].spatialReference, _n11 = !0 === e[0].hasZ, _i5 = !0 === e[0].hasM);
    } else if (e instanceof r) _a3 = e._elements, _a3.length > 0 && (_n11 = e._hasZ, _i5 = e._hasM, _o3 = e.get(0).spatialReference);else if (z(e)) {
      var _iterator10 = _createForOfIteratorHelper(e.toArray()),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _t15 = _step10.value;
          he(_a3, _t15);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      _a3.length > 0 && (_o3 = e.get(0).spatialReference, _n11 = !0 === e.get(0).hasZ, _i5 = !0 === e.get(0).hasM);
    }

    return 0 === _a3.length ? null : new l({
      points: _a3,
      spatialReference: _o3,
      hasZ: _n11,
      hasM: _i5
    });
  }

  return e;
}

function Se(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var r = [];
  if (null === e) return r;

  if (!0 === J(e)) {
    for (var _t16 = 0; _t16 < e.length; _t16++) {
      var _i6 = X(e[_t16]);

      "" === _i6 && !0 !== n || r.push(_i6);
    }

    return r;
  }

  if (e instanceof t) {
    for (var _t17 = 0; _t17 < e.length(); _t17++) {
      var _i7 = X(e.get(_t17));

      "" === _i7 && !0 !== n || r.push(_i7);
    }

    return r;
  }

  if (w(e)) {
    var _t18 = X(e);

    return "" === _t18 && !0 !== n || r.push(_t18), r;
  }

  return [];
}

var be = 0;

function Te(e) {
  return be++, be % 100 == 0 ? (be = 0, i(function (t) {
    setTimeout(function () {
      t(e);
    }, 0);
  })) : e;
}

function Ne(e, t, n) {
  switch (n) {
    case "&":
      return e & t;

    case "|":
      return e | t;

    case "^":
      return e ^ t;

    case "<<":
      return e << t;

    case ">>":
      return e >> t;

    case ">>>":
      return e >>> t;
  }
}

function Me(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return null == e ? null : Y(e) || F(e) || Z(e) ? e : e instanceof u ? !0 === (null == n ? void 0 : n.keepGeometryType) ? e : e.toJSON() : e instanceof t ? e.toArray().map(function (e) {
    return Me(e, n);
  }) : e instanceof Array ? e.map(function (e) {
    return Me(e, n);
  }) : e instanceof Date ? e : null !== e && "object" == typeof e && void 0 !== e.castAsJson ? e.castAsJson(n) : null;
}

function ke(e, t, n, r, i) {
  return Re(e, t, n).then(function (e) {
    i[r] = e;
  });
}

function Re(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (e instanceof t && (e = e.toArray()), null == e) return a(null);
  if (w(e) || e instanceof u || e instanceof Date) return a(Me(e, r));

  if (e instanceof Array) {
    var _t19 = [],
        _i8 = [];

    var _iterator11 = _createForOfIteratorHelper(e),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var _a4 = _step11.value;
        null === _a4 || w(_a4) || _a4 instanceof u || _a4 instanceof Date ? _i8.push(Me(_a4, r)) : (_i8.push(null), _t19.push(ke(_a4, n, r, _i8.length - 1, _i8)));
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }

    return _t19.length > 0 ? o(_t19).then(function () {
      return _i8;
    }) : a(_i8);
  }

  return null !== e && "object" == typeof e && void 0 !== e.castAsJsonAsync ? e.castAsJsonAsync(n, r) : a(null);
}

var Ae = Object.freeze({
  __proto__: null,
  ReturnResultE: S,
  ImplicitResultE: b,
  NativeFunctionE: T,
  SizzleFunctionE: N,
  NativeFunction: M,
  ImplicitResult: k,
  ReturnResult: R,
  SizzleFunction: A,
  voidOperation: D,
  breakResult: j,
  continueResult: C,
  multiReplace: _,
  isFunctionParameter: v,
  isSimpleType: w,
  defaultUndefined: O,
  isString: Z,
  isBoolean: Y,
  isNumber: F,
  isInteger: I,
  isArray: J,
  isFeatureSet: L,
  isFeatureSetCollection: E,
  isImmutableArray: z,
  isDate: G,
  pcCheck: P,
  absRound: V,
  generateUUID: H,
  formatNumber: U,
  formatDate: q,
  standardiseDateFormat: $,
  greaterThanLessThan: W,
  equalityTest: Q,
  toString: X,
  toNumberArray: K,
  toStringExplicit: ee,
  toNumber: ne,
  toDate: re,
  toDateTime: ie,
  toBoolean: oe,
  fixSpatialReference: se,
  fixNullGeometry: ue,
  getDomainValue: le,
  getDomainCode: fe,
  getDomain: ce,
  stableStringify: ge,
  autoCastFeatureToGeometry: de,
  autoCastArrayOfPointsToPolygon: pe,
  autoCastArrayOfPointsToPolyline: ye,
  autoCastArrayOfPointsToMultiPoint: xe,
  toStringArray: Se,
  tick: Te,
  binaryOperator: Ne,
  castAsJson: Me,
  castAsJsonAsync: Re
});
export { q as $, ce as A, le as B, fe as C, I as D, O as E, $ as F, ie as G, V as H, k as I, ue as J, de as K, ye as L, pe as M, M as N, xe as O, _ as P, H as Q, R, A as S, K as T, Te as U, Se as V, S as W, b as X, T as Y, N as Z, U as _, J as a, ge as a0, z as b, v as c, X as d, Q as e, Z as f, W as g, Ne as h, Y as i, F as j, j as k, Ae as l, C as m, G as n, L as o, P as p, E as q, se as r, ee as s, ne as t, Me as u, D as v, Re as w, w as x, oe as y, re as z };